// extracted by mini-css-extract-plugin
module.exports = {"footerWrap":"Footer_footerWrap__nCSxC"};